import { SeatCharacteristic } from '@eti/schema-types';
export const iconMap = {
  [SeatCharacteristic.EconomyComfort]: 'economy',
  [SeatCharacteristic.FrontOfCabin]: 'frontrow',
  [SeatCharacteristic.LegSpace]: 'extralegroom',
  [SeatCharacteristic.Normal]: 'default',
  [SeatCharacteristic.Bassinet]: '',
  [SeatCharacteristic.Bulkhead]: '',
  [SeatCharacteristic.ElectronicConnection]: '',
  [SeatCharacteristic.Flatbed]: '',
  [SeatCharacteristic.LegRest]: '',
  [SeatCharacteristic.NoInfantAllowed]: '',
  [SeatCharacteristic.NotSuitableForChildren]: '',
  [SeatCharacteristic.Restricted]: '',
  [SeatCharacteristic.RestrictedRecline]: '',
  [SeatCharacteristic.SuitableForAdtWithInf]: ''
};
//# sourceMappingURL=iconMap.js.map